module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('edit-pane', {
    ref: "step1",
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "prgStep1",
    attrs: {
      "label-width": "110px"
    },
    model: {
      value: (_vm.intSub),
      callback: function($$v) {
        _vm.intSub = $$v
      },
      expression: "intSub"
    }
  }, [(this.intSub) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-action-status', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.status),
      callback: function($$v) {
        _vm.$set(_vm.step, "status", $$v)
      },
      expression: "step.status"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-priority', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.priority),
      callback: function($$v) {
        _vm.$set(_vm.step, "priority", $$v)
      },
      expression: "step.priority"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "offset": 4
    }
  }, [_c('span', [_vm._v("Person In Charge")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "offset": 2
    }
  }, [_c('span', [_vm._v("Cheque Received")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8,
      "offset": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px"
    }
  }, [_c('select-users', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.updated_by),
      callback: function($$v) {
        _vm.$set(_vm.step, "updated_by", $$v)
      },
      expression: "step.updated_by"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "offset": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "required": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "active-color": "#5ccdcd",
      "inactive-color": "#cd5c5c",
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intSub.chequeDone),
      callback: function($$v) {
        _vm.$set(_vm.intSub, "chequeDone", $$v)
      },
      expression: "intSub.chequeDone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("Approvals")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('span', [_vm._v("Submitted")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('span', [_vm._v("Completed")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('span', [_vm._v("Approved")])])], 1), _vm._v(" "), _vm._l((_vm.intSub.approvals), function(item, index) {
    return _c('el-row', {
      key: index
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": item.approver
      }
    }, [_c('el-date-picker', {
      attrs: {
        "id": 'sub' + index,
        "format": _vm.dateFormat,
        "placeholder": "Submitted",
        "disabled": _vm.dis
      },
      model: {
        value: (item.submittedOn),
        callback: function($$v) {
          _vm.$set(item, "submittedOn", $$v)
        },
        expression: "item.submittedOn"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', [_c('el-date-picker', {
      attrs: {
        "id": 'comp' + index,
        "format": _vm.dateFormat,
        "placeholder": "Completed",
        "disabled": _vm.dis
      },
      on: {
        "change": function($event) {
          return _vm.completedDate(item.completedOn, item.completed)
        }
      },
      model: {
        value: (item.completedOn),
        callback: function($$v) {
          _vm.$set(item, "completedOn", $$v)
        },
        expression: "item.completedOn"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', [_c('el-switch', {
      attrs: {
        "id": 'compYN' + index,
        "active-text": "Yes",
        "inactive-text": "No",
        "width": 58,
        "active-color": "#5ccdcd",
        "inactive-color": "#cd5c5c",
        "disabled": _vm.dis
      },
      on: {
        "change": function($event) {
          return _vm.completedToggle(item.completedOn, item.completed)
        }
      },
      model: {
        value: (item.completed),
        callback: function($$v) {
          _vm.$set(item, "completed", $$v)
        },
        expression: "item.completed"
      }
    })], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', [_vm._v("Required Documents")]), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v("Company Docs")]), _vm._v(" "), _c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intSub.companyDocs),
      callback: function($$v) {
        _vm.$set(_vm.intSub, "companyDocs", $$v)
      },
      expression: "intSub.companyDocs"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "label": "Company Profile"
    },
    model: {
      value: (_vm.intSub.companyDocs[0]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.companyDocs, 0, $$v)
      },
      expression: "intSub.companyDocs[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v("Letters")]), _vm._v(" "), _c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intSub.letters),
      callback: function($$v) {
        _vm.$set(_vm.intSub, "letters", $$v)
      },
      expression: "intSub.letters"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "label": "Offer Letter"
    },
    model: {
      value: (_vm.intSub.letters[0]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.letters, 0, $$v)
      },
      expression: "intSub.letters[0]"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Power of Attorney"
    },
    model: {
      value: (_vm.intSub.letters[1]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.letters, 1, $$v)
      },
      expression: "intSub.letters[1]"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "LOO"
    },
    model: {
      value: (_vm.intSub.letters[2]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.letters, 2, $$v)
      },
      expression: "intSub.letters[2]"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v("Tax Docs")]), _vm._v(" "), _c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intSub.taxDocs),
      callback: function($$v) {
        _vm.$set(_vm.intSub, "taxDocs", $$v)
      },
      expression: "intSub.taxDocs"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "label": "Quit Rent Tax"
    },
    model: {
      value: (_vm.intSub.taxDocs[0]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.taxDocs, 0, $$v)
      },
      expression: "intSub.taxDocs[0]"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Assessment"
    },
    model: {
      value: (_vm.intSub.taxDocs[1]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.taxDocs, 1, $$v)
      },
      expression: "intSub.taxDocs[1]"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "I.R. Letter"
    },
    model: {
      value: (_vm.intSub.taxDocs[2]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.taxDocs, 2, $$v)
      },
      expression: "intSub.taxDocs[2]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v("Structure / Tower Docs")]), _vm._v(" "), _c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.intSub.towerDocs),
      callback: function($$v) {
        _vm.$set(_vm.intSub, "towerDocs", $$v)
      },
      expression: "intSub.towerDocs"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "label": "Insurance"
    },
    model: {
      value: (_vm.intSub.towerDocs[0]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.towerDocs, 0, $$v)
      },
      expression: "intSub.towerDocs[0]"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Tower Calculation"
    },
    model: {
      value: (_vm.intSub.towerDocs[1]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.towerDocs, 1, $$v)
      },
      expression: "intSub.towerDocs[1]"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Land Title"
    },
    model: {
      value: (_vm.intSub.towerDocs[2]),
      callback: function($$v) {
        _vm.$set(_vm.intSub.towerDocs, 2, $$v)
      },
      expression: "intSub.towerDocs[2]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', [_c('h5', [_vm._v("General Remarks")]), _vm._v(" "), _c('div', [_c('html-input', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1), _vm._v(" "), (_vm.step.remarks) ? _c('hr') : _vm._e()]), _vm._v(" "), _c('el-row', [_c('h3', [_vm._v("Review & Approval")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [(_vm.step) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Reviewer"
    }
  }, [_c('select-users', {
    attrs: {
      "manager": ""
    },
    model: {
      value: (_vm.step.approved_by),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved_by", $$v)
      },
      expression: "step.approved_by"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Review Date",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.dateFormat,
      "placeholder": "Reviewed",
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.approved_at),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved_at", $$v)
      },
      expression: "step.approved_at"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step) ? _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "active-color": "#5ccdcd",
      "inactive-color": "#cd5c5c",
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.approved),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved", $$v)
      },
      expression: "step.approved"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.rowData.id) ? _c('files-panel', {
    attrs: {
      "type": "site",
      "id": _vm.rowData.site_id,
      "process": "progress",
      "process-id": _vm.rowData.id,
      "disabled": _vm.dis,
      "max-files": 20
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74cd786a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressStep1.vue
// module id = 1564
// module chunks = 0